import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { useMutation } from "react-query";
import { BASEURL } from "../../../utils/BaseUrl";
import { useOtpSTatus } from "../../../context/OtpContext";
import { useNavigate } from "react-router-dom";
import CircleLoading from "../../../common/Loading/CircleLoading";
import Swal from "sweetalert2";

const OtpValidationInput = ({ length = 6 }) => {
  const [otp, setOtp] = useState(new Array(length).fill(""));
  const [time, setTime] = useState(20);
  const [timeLeft, setTimeLeft] = useState(900); // 900 seconds = 15 minutes

  useEffect(() => {
    if (timeLeft <= 0) return; // Stop countdown at 0

    const timer = setInterval(() => {
      setTimeLeft((prevTime) => prevTime - 1);
    }, 1000);

    return () => clearInterval(timer); // Cleanup on unmount
  }, [timeLeft]);

  // Format time (MM:SS)
  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}:${secs < 10 ? "0" : ""}${secs}`;
  };
  const firstInputRef = useRef();
  const { otpStatus, setOtpStatus, otpEmail, setOtpEmail, brochedureId } =
    useOtpSTatus();
  const navigate = useNavigate();
  const handleChange = (value, index) => {
    if (!/^[0-9]?$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < length - 1) {
      document.getElementById(`otp-input-${index + 1}`).focus();
    }
  };
  useEffect(() => {
    if (time > 0) {
      const timer = setInterval(() => {
        setTime((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(timer);
    }
  }, [time]);

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      document.getElementById(`otp-input-${index - 1}`).focus();
    }
  };
  useEffect(() => {
    if (firstInputRef.current) {
      firstInputRef.current.focus();
    }
  }, []);

  const mutation = useMutation({
    mutationFn: (values) => {
      return axios.post(`${BASEURL}verify-otp`, values);
    },
    onSuccess: () => {
      Swal.fire({
        title: "Your Otp verify successfull",
        icon: "success",
        draggable: false,
        // confirmButtonColor:"#fcd70c",
        customClass: {
          confirmButton: "custom-confirm-button", // Add a custom class for styling
        },
      }).then(() => {
        brocedureDownload();
        setOtpStatus();
      });
    },
    onError: () => {
      Swal.fire({
        title: "Invalid OTP",
        icon: "error",
        draggable: false,
        // confirmButtonColor:"#fcd70c",
        customClass: {
          confirmButton: "custom-confirm-button", // Add a custom class for styling
        },
      });
      firstInputRef.current.focus();
      setOtp(new Array(length).fill(""));
    },
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    const values = {
      email: otpEmail,
      otp: otp.join(""),
    };
    mutation.mutate(values);
  };

  const mutationResend = useMutation({
    mutationFn: (values) => {
      return axios.post(`${BASEURL}send-otp`, values);
    },
  });

  const brocedureDownload = async () => {
    const pdfUrl = `${BASEURL}brochures?email=${otpEmail}&id=${brochedureId}`;
    console.log(pdfUrl,"pdfUrl");
    
    const link = document.createElement("a");
    link.href = pdfUrl;
    link.download = "document.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    navigate("/allbrocedure");
  };

  const handleResend = () => {
    const values = {
      email: otpEmail,
    };
    mutationResend.mutate(values);

    if (mutationResend.isSuccess) {
      Swal.fire({
        title: "Resend SuccessFully",
        icon: "success",
        draggable: false,
        // confirmButtonColor:"#fcd70c",
        customClass: {
          confirmButton: "custom-confirm-button", // Add a custom class for styling
        },
      }).then(() => {
        setTimeLeft(900);
        firstInputRef.current.focus();
      });

      setTime(20);
    }
  };

  return (
    <div className="w-full h-screen flex items-center justify-center">
      <div class="emailform-container">
        <div class="logo-container">
          Please Enter the OTP sent to
          <br />
          <span className="text-forging-yellow">
            {otpEmail}{" "}
            <span
              className="text-blue-800 cursor-pointer"
              onClick={() => setOtpStatus(false)}
            >
              Change
            </span>
          </span>
        </div>
        <div className="flex justify-center">
          <p className="text-md font-semibold">
            OTP expired in :{" "}
            <span className="text-forging-yellow"> {formatTime(timeLeft)}</span>
          </p>
        </div>

        <form class="form" onSubmit={(e) => handleSubmit(e)}>
          <div class="form-group">
            <label for="email">Email</label>
            <div className="otp-input-box">
              {otp.map((value, index) => (
                <input
                  key={index}
                  id={`otp-input-${index}`}
                  type="text"
                  maxLength={1}
                  value={value}
                  onChange={(e) => handleChange(e.target.value, index)}
                  onKeyDown={(e) => handleKeyDown(e, index)}
                  ref={index === 0 ? firstInputRef : null}
                />
              ))}
            </div>
          </div>

          <button class="form-submit-btn" type="submit">
            {mutation.isLoading ? <CircleLoading /> : "Verify OTP"}
          </button>
        </form>

        <div className="text-center -mt-4 text-md cursor-pointer">
          Not received your code?{" "}
          {time > 0 ? (
            `00:${time}`
          ) : (
            <span
              onClick={() => handleResend()}
              className="font-bold text-forging-yellow cursor-pointer"
            >
              Resend
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default OtpValidationInput;
